import { NumberChart } from "components/modules/charts/NumberChart";
import { useDDFilter } from "components/modules/disinfectionFilter/DisinfectionFilterPanel";
import { DisinfectionFilter } from "gql/graphql";
import { FormattedMessage } from "react-intl";
import { useParams } from "react-router-dom";
import { useQueryWithSnack } from "utils/useQueryWithSnack";
import { DISINFECTIONS_BY_ROOM_QUERY } from "./DisinfectionsByRoomTable";

interface Props {
  hiddenFilter?: DisinfectionFilter;
}

export const UniqueDepartmentsChart = ({ hiddenFilter }: Props) => {
  const { orgId } = useParams();
  const [filterParams] = useDDFilter();

  const { data, loading } = useQueryWithSnack(DISINFECTIONS_BY_ROOM_QUERY, {
    variables: {
      filter: {
        ...filterParams,
        ...hiddenFilter,
        ...(orgId ? { organizationIds: [orgId] } : {}),
      },
    },
  });

  const uniqueDepartmentCount = new Set( //Use Set() to remove duplicates
    data?.disinfectionRooms
      .filter((item: any) => item.department) // Discard rooms without department
      .map((item: any) => item.department),
  ).size;

  return (
    <NumberChart
      header={
        <FormattedMessage
          id="unique-departments"
          defaultMessage="Unique Departments"
        />
      }
      description={
        <FormattedMessage
          id="unique-departments-description"
          defaultMessage="Number of unique departments disinfected"
        />
      }
      value={uniqueDepartmentCount ?? 0}
      loading={loading}
    />
  );
};
